import axios from "@axios";


export default {
  namespaced: true,
  state: {
    items: [],
  },
  getters: {
    getItems(state) {
      return state.items;
    },
    getSelectedItems(state) {
      return new Map(state.items.map(item => [item.camera.camera_proxy_id, item.camera.name]));
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value;
    },
  },
  actions: {

    //getAll Retrieves all rules for the grid table view.
    async getAll({ commit }, params) {
      const { data } = await axios.get(`${window.__env.VUE_APP_BASE_URL}/v1/proxy_camera`,{ params });

      if (!data) {
        return [];
      }

      commit("setData", data.data);
      return data;
    },
    

    //clear Clears the stored list of rules in the state.
    clear({ commit }) {
      commit("setData", []);
    },
  },
};
